export const questionsPageData = {
  header: {
    title: "Najczęstsze Pytania",
    subtitle:
      "Masz wątpliwości? Znajdź odpowiedź na pytania, które zadają nam nasi klienci",
  },
  buttons: {
    backLabel: "Powrót do strony głównej",
  },
};
